import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { Droplets, Activity, MapPin, Calendar } from "lucide-react";
import "./glass-admin.css"; // adjust path if needed

const DashboardComponent = () => {
    // Dashboard summary values (kept only if needed later)

    return (
        <Container fluid className="min-vh-100 glass-admin-bg">
            {/* Header */}
            <Row className="pt-4 pb-3">
                <Col>
                    <Card className="border-0 shadow-sm glass-surface">
                        <Card.Body className="py-3">
                            <Row className="align-items-center">
                                <Col xs={12} md={6}>
                                    <div className="d-flex align-items-center">
                                        <span className="fs-5 fw-medium text-muted">
                                            Local Irrigator System Assessment
                                        </span>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} className="text-md-end mt-3 mt-md-0">
                                    <div className="d-flex justify-content-md-end justify-content-start align-items-center flex-wrap gap-2">
                                        <Badge bg="light" text="dark" className="px-2 py-1">
                                            <MapPin size={14} className="me-1" />
                                            Regional
                                        </Badge>
                                        <Badge bg="light" text="dark" className="px-2 py-1">
                                            <Calendar size={14} className="me-1" />
                                            Q2 2025
                                        </Badge>
                                        <Badge bg="light" text="dark" className="px-2 py-1">
                                            <Activity size={14} className="me-1" />
                                            Active
                                        </Badge>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Main Content with Fixed Sidebar */}
            <Row className="pb-4">
                <div className="d-flex gap-3">
                    {/* Main Content - Flexible Width */}
                    <div style={{ flex: '1' }}>
                        <Card className="h-100 border-0 shadow-lg glass-surface">
                            <Card.Body className="d-flex flex-column justify-content-center p-5">
                                <div className="mb-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <Droplets size={48} style={{ color: '#059669' }} className="me-3" />
                                        <div>
                                            <h1 className="display-4 fw-bold mb-0" style={{ color: '#059669' }}>L.I.S.A</h1>
                                            <div className="border-bottom" style={{ 
                                                width: '80px', 
                                                height: '3px', 
                                                backgroundColor: '#059669',
                                                borderColor: '#059669'
                                            }}></div>
                                        </div>
                                    </div>
                                    <h2 className="h3 text-muted fw-medium mb-4">
                                        Local Irrigator System Assessment
                                    </h2>
                                    
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <Card className="border-0 glass-surface glass-surface--thin h-100">
                                                <Card.Body className="text-center">
                                                    <Activity style={{ color: '#10b981' }} className="mb-2" size={32} />
                                                    <h5 className="fw-bold" style={{ color: '#10b981' }}>System Status</h5>
                                                    <p className="text-muted mb-0">Monitoring Active</p>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                        <div className="col-md-6">
                                            <Card className="border-0 glass-surface glass-surface--thin h-100">
                                                <Card.Body className="text-center">
                                                    <MapPin style={{ color: '#059669' }} className="mb-2" size={32} />
                                                    <h5 className="fw-bold" style={{ color: '#059669' }}>Coverage Area</h5>
                                                    <p className="text-muted mb-0">Multi-Regional</p>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>

                   
                </div>
            </Row>
        </Container>
    );
};

export default DashboardComponent;